import { useThemeStore } from "@stores/theme.store";
import { Button, DatePicker, Form, Input, message, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { PopupSuccess } from "@components/general/popup";

import { PermitService } from "@services/permit.service";
import { NoticeType } from "antd/es/message/interface";
import { SchoolService } from "@services/school.service";
import moment from "moment";
// const { Option } = Select;
// moment.locale("id");
export const PermitPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [thisDate, setThisDate] = useState<string>("");
  const [startDate, setStartDate] = useState<Date | null>(null);

  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");
  const [showMessage, setShowMessage] = useState<boolean>(false);

  const [popupSuccess, setPopupSuccess] = useState<boolean>(false);
  const [listOpenDate, setListOpenDate] = useState<Date[]>([]);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data: settings } = useQuery({
    queryKey: [PermitService.queries.GET_PERMIT_SETTING],
    queryFn: PermitService.setting,
  });

  const { mutate, isPending } = useMutation({
    mutationFn: PermitService.request,
    onSuccess: (response) => {
      if (response.success) {
        // setPopupSuccess(true);
        setShowMessage(true);
        setMessageType("success");
        setShowMessageText(response.message);
        form.resetFields();
        // refetchPermitData();
      } else {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(response.message);
      }
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  const onChangeDate = (date: Date | null) => {
    if (date != null) {
      const formattedDate = dayjs(date).format("YYYY-MM-DD");
      setThisDate(formattedDate);
      setStartDate(date);
    }
  };

  const onChangeMode = (value: string | undefined) => {
    const nameMode = value ?? "";

    const dates = (settings?.data ?? [])
      .filter((item) => item.mode === nameMode)
      .map((item) => {
        const date = moment(item.date).toDate();
        return date;
      });

    setListOpenDate(dates.filter((date): date is Date => date !== null));
    setStartDate(null);
    form.setFieldsValue({ dateBack: "", datePermit: "" });
  };

  // const onSubmitPermit = (data: Permit) => {
  //   mutate({
  //     ...data,
  //     datePermit: thisDate,
  //     dateBack: thisDate,
  //   });
  // };

  useEffect(() => {
    setAppBar({ title: "Request Izin", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Request Izin",
      image: false,
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <Form
          form={form}
          className=""
          autoComplete="off"
          onFinish={(data) => {
            mutate({
              ...data,
              nis: nis,
              datePermit: dayjs(data.datePermit).format("YYYY-MM-DD"),
              dateBack: dayjs(data.datePermit).format("YYYY-MM-DD"),
            });
          }}
        >
          <div className="card-body">
            <Form.Item label="Pilih Izin" name="mode" className="tw-mb-4">
              <Select
                className=" tw-text-base"
                placeholder="Pilih izin"
                allowClear
                options={[
                  { value: "Pulang", label: "Perizinan Pulang" },
                  { value: "Sekitar Kota", label: "Perizinan Sekitar Kota" },
                  {
                    value: "Keluar Kota/Menginap",
                    label: "Perizinan Keluar Kota/Menginap",
                  },
                ]}
                onChange={onChangeMode}
              ></Select>
            </Form.Item>

            <Form.Item
              label="Nama Penjemput"
              name="pickup"
              className="tw-mb-4"
              rules={[
                { required: true, message: "Nama Penjemput harus diisi!" },
              ]}
            >
              <Input
                className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Nama Penjemput"
              />
            </Form.Item>

            <Form.Item
              label="Tanggal Izin"
              name="datePermit"
              className="tw-mb-4"
              rules={[{ required: true, message: "Tanggal Izin harus diisi!" }]}
            >
              <DatePicker
                className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Tanggal Izin"
                minDate={dayjs()}
                maxDate={dayjs().add(2, "months")}
                format="YYYY-MM-DD"
                disabledDate={(currentDate: Dayjs) =>
                  !listOpenDate.some((date: Date) =>
                    dayjs(date).isSame(currentDate, "day")
                  )
                }
                onChange={onChangeDate}
                inputReadOnly={true}
              />
            </Form.Item>

            <Form.Item
              label="Alasan Izin"
              name="notes"
              className="tw-mb-4"
              rules={[{ required: true, message: "Alasan Izin harus diisi!" }]}
            >
              <Input
                className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Alasan Izin"
              />
            </Form.Item>
          </div>
          {/* <div className="tw-mt-3 card-body"> */}
          <Button
            type="primary"
            htmlType="submit"
            loading={isPending}
            className="tw-p-2 tw-mt-4 tw-h-10 tw-w-full tw-text-base tw-rounded-xl bg-gradient tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            {isPending ? "" : "Request Izin"}
          </Button>
          {/* </div> */}
        </Form>
      </div>

      <PopupSuccess
        open={popupSuccess}
        title="Berhasil!"
        message="Berhasil membuat permintaan izin!"
        textConfirm="Tutup"
        onConfirm={() => setPopupSuccess(false)}
      />
    </>
  );
};
